import { Loader } from '@components/loader';
import { AcquirerLinkPage } from '@pages/acquirerLinks/id';
import { useGetAcquirerLink } from '@services/staff/acquirer/links/get';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';

function AcquirerLink() {
  const { acquirerId, id, localId } = useParams({
    from: '/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/',
  });
  const navigate = useNavigate();
  const { data, isPending } = useGetAcquirerLink({ acquirerId, id });

  if (isPending) return <Loader />;
  if (!data) return null;

  return (
    <AcquirerLinkPage
      acquirerLink={data}
      acquirerId={acquirerId}
      handleDuplicateRedirect={() => {
        navigate({
          to: '/u/$localId/staff/acquirers/$acquirerId/links/new',
          params: { acquirerId, localId },
          search: { duplicateFrom: data.id },
        }).catch((err) => console.error(err));
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['acquirer_links_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: AcquirerLink,
});
